export default {
  form: {
    gtin: {
      label: 'GTIN',
    },
    pfand: {
      label: 'Kaucja za butelkę',
    },
    product_type: {
      label: 'Typ produktu',
      options: {
        packaged: 'Pakowany',
        prepared: 'Przygotowany',
      },
    },
    packaging_material: {
      label: 'Materiał opakowania',
    },
    brand_or_manufacturer: {
      label: 'Marka lub producent',
    },
    net_quantity: {
      label: 'Ilość netto',
    },
    base_price: {
      label: 'Ustaw cenę za jednostkę (np. za litr napoju)',
      placeholder: 'Cena za jednostkę',
    },
    alcohol_by_volume_percent: {
      label: 'Zawartość alkoholu',
    },
    caffeine_mg_per_100ml: {
      label: 'Kofeina (mg na 100 ml produktu)',
    },
    ingredients_text: {
      label: 'Składniki',
    },
    allergens_list: {
      label: 'Alergeny',
    },
    additives_list: {
      label: 'Dodatki',
    },
    has_nutrition_table: {
      label: 'Wypełnij tabelę wartości odżywczych (na 100{{unit}} produktu)',
    },
    energy_kj: {
      label: 'Energia (kJ)',
    },
    energy_kcal: {
      label: 'Energia (kcal)',
    },
    fat_g: {
      label: 'Tłuszcze',
    },
    saturates_g: {
      label: 'Kwasy tłuszczowe nasycone',
    },
    carbohydrate_g: {
      label: 'Węglowodany',
    },
    sugars_g: {
      label: 'Cukry',
    },
    protein_g: {
      label: 'Białko',
    },
    salt_g: {
      label: 'Sól',
    },
    identifiers: {
      label: 'Identyfikatory',
    },
  },
};
